import { useI18n } from '@oneaudi/i18n-context';
export const useFinanceTranslations = () => ({
    webcalcTechError: useI18n({
        id: 'stockcars.financing.calculation.error',
        defaultMessage: '',
    }),
    headline: useI18n({
        id: 'nemo.ui.sc.details.finance.form.headline',
        defaultMessage: '',
    }),
    headlineNew: useI18n({
        id: 'nemo.ui.sc.details.finance.form.headline.new',
        defaultMessage: '',
    }),
    headlineUsed: useI18n({
        id: 'nemo.ui.sc.details.finance.form.headline.used',
        defaultMessage: '',
    }),
    productHeadline: useI18n({
        id: 'nemo.ui.sc.details.finance.form.productheadline',
        defaultMessage: '',
    }),
    singleProductHeadline: useI18n({
        id: 'nemo.ui.sc.details.finance.form.singleProductheadline',
        defaultMessage: '',
    }),
    formHeadline: useI18n({
        id: 'nemo.ui.sc.details.finance.form.dataheadline',
        defaultMessage: '',
    }),
    financeRateLabelSuffix: useI18n({
        id: 'nemo.ui.sc.details.finance.form.rate.label.suffix',
        defaultMessage: '',
    }),
    calculateButton: useI18n({
        id: 'nemo.ui.sc.details.finance.form.button.calculate',
        defaultMessage: '',
    }),
    updateButton: useI18n({
        id: 'nemo.ui.sc.details.finance.form.button.update',
        defaultMessage: '',
    }),
    disclaimerHeadline: useI18n({
        id: 'nemo.ui.sc.details.finance.form.disclaimer',
        defaultMessage: '',
    }),
    helpPopup: useI18n({
        id: 'nemo.ui.sc.details.finance.form.help.label',
        defaultMessage: '',
    }),
    calculationError: useI18n({
        id: 'nemo.ui.sc.details.finance.form.calculationError',
        defaultMessage: '',
    }),
    resetButton: useI18n({
        id: 'nemo.ui.sc.details.finance.form.button.reset',
        defaultMessage: '',
    }),
    buyOnline: useI18n({
        id: 'nemo.ui.sc.details.finance.form.button.buyOnline',
        defaultMessage: '',
    }),
    close: useI18n({
        id: 'nemo.ui.sc.details.finance.form.button.close',
        defaultMessage: '',
    }),
    contactDealer: useI18n({
        id: 'nemo.ui.sc.details.finance.form.button.contactDealer',
        defaultMessage: '',
    }),
    updateBtn: useI18n({
        id: 'nemo.ui.sc.details.finance.form.button.update',
        defaultMessage: '',
    }),
    modalitiesUCHeading: useI18n({
        id: 'stockcars.uc.financing.selection.headline',
        defaultMessage: '',
    }),
    modalitiesNCHeading: useI18n({
        id: 'stockcars.nc.financing.selection.headline',
        defaultMessage: '',
    }),
    cashOnlyUCHeading: useI18n({
        id: 'stockcars.uc.financing.selection.cash.heading',
        defaultMessage: '',
    }),
    cashOnlyUCTxt: useI18n({
        id: 'stockcars.uc.financing.selection.cash.txt',
        defaultMessage: '',
    }),
    cashOnlyNCHeading: useI18n({
        id: 'stockcars.nc.financing.selection.cash.heading',
        defaultMessage: '',
    }),
    cashOnlyNCTxt: useI18n({
        id: 'stockcars.nc.financing.selection.cash.txt',
        defaultMessage: '',
    }),
    cashFSNCHeading: useI18n({
        id: 'stockcars.nc.cash.headline',
        defaultMessage: '',
    }),
    cashFSUCHeading: useI18n({
        id: 'stockcars.uc.cash.headline',
        defaultMessage: '',
    }),
});
